/** EN uses Swedish values until translated. */
export const siteCommonEn = {
    loading: {
        issues: 'Loading issue data...',
        calendar: 'Loading calendar data...',
        companies: 'Loading company data...',
        warrants: 'Loading warrant data...',
        convertibles: 'Loading convertible data...',
    },
    actions: {
        showMore: 'Show more',
        showLess: 'Show less',
        showAll: 'Show all',
        showTable: 'Show table',
        hideTable: 'Hide table',
        showDetailed: 'Show details',
        hideDetailed: 'Hide details',
        showAdvancedFilters: 'Show advanced filters',
        hideAdvancedFilters: 'Hide advanced filters',
        edit: 'Edit',
        delete: 'Remove',
        cancel: 'Cancel',
        save: 'Save',
        showCompletedConvertibles: 'View completed convertible loans',
    },
    filters: {
        allOf: 'All {{label}}',
        selectionOf: 'Selection of {{label}}',
        showAll: 'Show all',
        showAllOptions: 'Show all warrants',
        onlyListedOptions: 'Show listed warrants',
        onlyUnlistedOptions: 'Show unlisted warrants',
        onlyCompletedIssues: 'Show only completed issues',
        hideCompletedIssues: 'Hide completed issues',
        allCompanies: 'All companies',
        allIssues: 'All issues',
        industry: 'Sectors',
        industries: 'Sectors',
        lists: 'Marketplaces',
        watchListOnly: 'Watchlist only',
        watchListOnlyAria: 'Favourites only',
        min: 'Min',
        max: 'Max',
        minimumDistanceAria: 'Minimum distance',
    },
    notCommunicatedYet: 'Not communicated yet',
    notAvailable: 'N/A',
    missing: 'Missing',
    pagination: {
        previous: 'Previous',
        next: 'Next',
        later: 'Later',
    },
    pricing: {
        vwapDiscount: 'VWAP discount',
        min: 'Min:',
        max: 'Max:',
        parValue: 'Qutoa value',
        fixedPrice: 'Fixed price',
        perShare: 'per share',
        days: 'days',
        day: 'day',
    },
    weekdays: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
    },
    dates: {
        today: 'Today',
        periodStart: 'Time period start',
        periodEnd: 'Time period end',
        start: 'Start date',
        end: 'End date',
    },
    table: {
        total: 'Sum',
        count: 'Amount',
        name: 'Name',
        amount: 'Amount',
        share: 'Share',
        type: 'Type',
        date: 'Date',
        percent: 'Percentage',
        min: 'Min',
        max: 'Max',
        average: 'Average',
    },
    admin: {
        editLink: '[Edit]',
        viewAdminPr: '[Show admin pm]',
    },
    footer: {
        termsOfUse: 'Terms of use',
        privacyPolicy: 'Privacy policy',
    },
}
